import React from 'react';
import PropTypes from 'prop-types';
import { getDealershipWriteReviewLink } from 'site-modules/shared/utils/dealership-link-constructor';
import { DEALER_PROPS } from 'client/constants/dealer-reviews';

export function WriteAReviewLink({
  params: { dealerState, dealerCity, logicalName },
  reviewsType,
  showroomPage,
  noFollow,
}) {
  const writeReviewLink = getDealershipWriteReviewLink({
    state: dealerState,
    city: dealerCity,
    dealership: logicalName,
    reviewType: reviewsType,
    showroomPage,
  });
  return (
    <a
      href={writeReviewLink}
      className="write-review-link btn btn-link fw-normal text-transform-none size-16 px-0 py-0"
      data-tracking-id="ddp_go_to_review_form"
      {...noFollow && { rel: 'nofollow' }}
    >
      <span className="text-underline">Write a {reviewsType} review</span>
      <i className="small icon-arrow-right3 ps-0_25" aria-hidden />
    </a>
  );
}

WriteAReviewLink.propTypes = {
  reviewsType: PropTypes.string.isRequired,
  params: DEALER_PROPS.isRequired,
  noFollow: PropTypes.bool,
  showroomPage: PropTypes.string,
};

WriteAReviewLink.defaultProps = {
  noFollow: false,
  showroomPage: null,
};
